angular.module('elogbooksServices').service('modulesService', function ($http, elbSettings, apiClient, $q) {

    var self = this;

    this.enabled = undefined;
    this.modules = {};

    this.load = function (rootResourceResponse) {
        if (self.enabled) {
            return $q.when(self.enabled);
        }

        if (rootResourceResponse) {
            return fetchModules(rootResourceResponse);
        }

        return apiClient.get('/').then(function(rootResponse) {
            return fetchModules(rootResponse);
        });
    };

    function fetchModules(rootResponse) {
        if (rootResponse && rootResponse.getLink('modules')) {
            return apiClient.get(rootResponse.getLink('modules'), null, true).then(function (moduleResponse) {
                var modulesEnabled = {};
                if (moduleResponse && moduleResponse.settings) {
                    angular.forEach(moduleResponse.settings, function (value) {
                        var name = value.name.split(':')[0];
                        modulesEnabled[name] = value.value;
                        self.modules[name] = value;
                    });
                }
                self.enabled = modulesEnabled;
                return modulesEnabled;
            });
        }
        self.enabled = {};
        return [];
    }

    this.getAll = function () {
       return $http.get('/data/modules.json');
    };

    this.getEnabled = function (module) {
        if (! module) {
            return self.enabled;
        }

        return self.enabled[module];
    };

    this.isEnabled = function (module) {
        var keys = [
            module,
            module + '_module_enabled', // Check for audits_module_enabled
            module + '_enabled'         // Check for audits_enabled
        ];

        // Check local memory first
        if (self.enabled) {
            for (var i = 0; i < keys.length; i++) {
                if (self.enabled.hasOwnProperty(keys[i]) && self.enabled[keys[i]] === true) {
                    return true;
                }
            }
        }

        // Fallback to elbSettings
        for (var j = 0; j < keys.length; j++) {
            var setting = elbSettings.getSetting(keys[j]);
            if (setting && setting.value === true) {
                return true;
            }
        }

        return false;
    };

    this.oneOfEnabled = function (modules) {
        var result = false;
        angular.forEach(modules, function(module) {
            if (self.isEnabled(module)) {
                result = true;
            }
        });

        return result;
    };

    this.thirdPartyIntegrations = function() {
        var integrations = ['riskwise', 'meridian', 'alcumus', 'datastation', 'propertyplus', 'prism'];

        return integrations.map(function(integration) {
            if (!self.enabled.hasOwnProperty(integration + '_enabled')) {
                return null;
            }

            return integration;
        }).filter(Object);
    }

    this.enabledModules = function(modules) {
        return modules.filter(self.isEnabled);
    }

    this.checkIntegrationsEnable = function() {
        return this.oneOfEnabled(
            [
                'riskwise',
                'meridian',
                'alcumus',
                'datastation',
                'propertyplus',
                'prism'
            ]);
    }

    this.getModuleSetting = function (moduleName) {
        if (self.modules && self.modules[moduleName]) {
            return self.modules[moduleName];
        }
        return null;
    };

    return this;
});
